/*! PawLab mobile overflow — unpin innerWidth px locks; keep desktop 7-up + 16:9 hero */
(function () {
  function layoutWidth() {
    var client = document.documentElement ? document.documentElement.clientWidth : 0;
    return client || window.innerWidth || 0;
  }

  function unpinFilm() {
    document.querySelectorAll(".pawlab-film-section, [data-pawlab-film]").forEach(function (el) {
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("max-width", "100%", "important");
      el.style.setProperty("min-width", "0", "important");
    });
  }

  function capCategory() {
    var root = document.querySelector('[id*="__collection_list_shopCategory"]');
    if (!root) return;
    root.style.setProperty("width", "100%", "important");
    root.style.setProperty("max-width", "100%", "important");
    root.style.setProperty("overflow-x", "clip", "important");
    if (layoutWidth() >= 750) return;
    var card = "calc((100% - 1rem) / 3)";
    root.style.setProperty("--mobile-card-size", card, "important");
    root.style.setProperty("--pawlab-cat-card", card, "important");
    root.style.setProperty("--slide-width-max", card, "important");
    root.style.setProperty("--column-count-mobile", "3", "important");
    root.querySelectorAll("slideshow-slide, .resource-list__slide").forEach(function (el) {
      el.style.setProperty("min-width", "0", "important");
      el.style.setProperty("max-width", card, "important");
    });
  }

  function run() {
    unpinFilm();
    capCategory();
  }

  run();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
  window.addEventListener("resize", run, { passive: true });
  setTimeout(run, 60);
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();
